import { Component, OnInit, ChangeDetectionStrategy, Injector } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogAbstractComponent } from '../../../../../shared/dialogs/dialog.class';
import { UtilService } from '../../../../../services/util.service';

@Component({
  selector: 'app-pdf-image-preview',
  templateUrl: './pdf-image-preview.component.html',
  styleUrls: ['./pdf-image-preview.component.scss'],
})
export class PdfImagePreviewComponent extends DialogAbstractComponent implements OnInit {
  uploadedFile;

  loadingFile = false;
  constructor(private domSanitizer: DomSanitizer, private utilService: UtilService, injector: Injector) {
    super(injector);
  }

  async ngOnInit() {
    if (this.dialogParams?.s3Url) {
      try {
        this.loadingFile = true;
        let base64 = await this.utilService.getBase64StreamUsingS3(this.dialogParams.s3Url);
        base64 = `data:image/jpg;base64,${base64}`;
        this.uploadedFile = this.domSanitizer.bypassSecurityTrustResourceUrl(base64 + '#toolbar=0&navpanes=0&scrollbar=0');
        this.loadingFile = false;
      } catch (e) {
        this.loadingFile = false;
      }
    } else if (this.dialogParams?.baseUrl) {
      this.uploadedFile = this.dialogParams?.baseUrl;
    }
  }
}
